import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';
Vue.use(VueRouter);

const routes = [
  {
    path: '/smartRestaurant/index',
    name: 'smartRestaurant',
    component: () => import('@/sub-app/smartRestaurant/pages/index.vue'),
    meta: {
      title: '智慧餐厅',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
    // 设置webview标题
    let title = to.meta?.title || '';
    const urlParams = getURLSearchParams();
    if (urlParams && urlParams.title) {
      title = decodeURIComponent(urlParams.title);
    }
    document.title = title;
    next();
  });
  

export default router;
